import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";
// Import global business context
import { BusinessContextHolder } from "./BusinessContext.js";

axios.interceptors.response.use((response) => response, (error) => {
  if (error.response.status === 401 && localStorage.getItem('authorization-state-customer')) {
    localStorage.removeItem('authorization-state-customer');
    localStorage.removeItem('authorization-expire-customer');
    return window.location.href = '/login';
  }
  else if (error.response.status === 401 && localStorage.getItem('authorization-state-tutor')) {
    localStorage.removeItem('authorization-state-tutor');
    localStorage.removeItem('authorization-expire-tutor');
    return window.location.href = '/tutor';
  } 
  
  else if (error.response.status === 401 && localStorage.getItem('authorization-state')) {
    localStorage.removeItem('authorization-state');
    localStorage.removeItem('authorization-expire');
    return window.location.href = '/admin';
  } 
  return error;
});


ReactDOM.render(
  <React.StrictMode>
    <BusinessContextHolder>
      <App />
    </BusinessContextHolder>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
